import { Routing } from "@common/_constants";
import { Button } from "@common/components/Atoms/Button";
import AccountPage from "@pro/components/Molecules/AccountPage";
import * as React from "react";

class ErrorUnhandled extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        window.location.href = Routing.Client.Account.SIGN_OUT;
    }

    render() {
        return (
            <AccountPage
                title="Oops!"
                message="This is embarrassing. Something unexpected happened. Please refresh this page."
                updating={false}>
                <div className="c-block">
                    <Button id="continue" block={true} green={true} onClick={this.handleSubmit}>
                        refresh now
                    </Button>
                </div>
            </AccountPage>
        );
    }
}

export default ErrorUnhandled;
